export const namespaced = true;

export const state = {
    pending: {}, //active pnr
    queue: [], //pnrs waiting to be booked
    status: [] //status of pnrs completed booking
}

export const mutations = {
    SET_BOOKING_QUEUE(state, payload){
        state.queue = payload
    },
    /*
    DEL_KEY_FROM_QUEUE(state, key){
        const index = state.queue.findIndex(obj => obj.key === key);
        if (index > -1){
            state.queue.splice(index, 1);
        }  
    },
    */
    DEL_PNR_FROM_QUEUE(state, key){
        const index = state.queue.findIndex(obj => obj.bookingKey === key);
        if (index > -1){
            state.queue.splice(index, 1);
        }  
    },
    SAVE_BOOKING_STATUS(state, payload){
        state.status.push(payload);
    },
    CLEAR_BOOKING_STATUS(state){
        state.status = [];
    },
    SET_PNR_KEY(state, payload){
        state.pnr.key = payload;
    },
    SET_PNR_PENDING(state, payload){
        state.pending = payload;
    },
    SET_PNR_INFO(state, payload){
        state.info = payload;
    },
    SET_PNR_REQ(state, payload){
        state.req =payload;
    },
}